module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0702.c5b834a9.jpg";